// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const SelectedStatuses = t.list(KeyValuePair, 'SelectedStatuses');

export const getDefaultState = () => new SelectedStatuses([]);

export default SelectedStatuses;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/state/selected-statuses.js